<template>
    <vue-glide v-model="currentSlide" :rewind="false" :per-view="1">
        <vue-glide-slide>
            <div class="box-16-9">
                <iframe src="https://player.vimeo.com/video/467826391?title=0&byline=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
        </vue-glide-slide>

        <vue-glide-slide>
            <div class="box-16-9">
                <iframe src="https://player.vimeo.com/video/560099958?title=0&byline=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
        </vue-glide-slide>

        <template slot="control">
            <button
                data-glide-dir="<"
                class="w-6 sm:w-5 xl:w-6 focus:outline-none"
            >
                <svg class="w-full" :class="[currentSlide === 0 ? 'text-gray' : 'text-blue3']" fill="none" viewBox="0 0 27 24">
                    <path class="fill-current" d="M.94 13.06a1.5 1.5 0 010-2.12l9.545-9.547a1.5 1.5 0 112.122 2.122L4.12 12l8.486 8.485a1.5 1.5 0 11-2.122 2.122L.94 13.06zM27 13.5H2v-3h25v3z"/>
                </svg>
            </button>

            <div class="flex items-center justify-center w-20 sm:w-16 xl:w-20 py-6 sm:py-4 font-point-demo-bold text-blue3 text-2xl sm:text-xl xl:text-2xl 3xl:text-3xl"><span class="text-red2">{{ currentSlide + 1}}</span><span class="px-1">/</span><span>2</span></div>

            <button
                data-glide-dir=">"
                class="w-6 sm:w-5 xl:w-6 focus:outline-none"
            >
                <svg class="w-full" :class="[currentSlide === slides - 1 ? 'text-gray' : 'text-blue3']" fill="none" viewBox="0 0 27 24">
                    <path class="fill-current" d="M26.06 13.06a1.5 1.5 0 000-2.12l-9.545-9.547a1.5 1.5 0 10-2.122 2.122L22.88 12l-8.486 8.485a1.5 1.5 0 102.122 2.122l9.546-9.546zM0 13.5h25v-3H0v3z"/>
                </svg>
            </button>
        </template>
    </vue-glide>
</template>

<script>
import { Glide, GlideSlide } from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'

export default {
    components: {
        [Glide.name]: Glide,
        [GlideSlide.name]: GlideSlide
    },

    data() {
        return {
            slides: 2,
            currentSlide: 0
        }
    }
}
</script>

<style>
[data-glide-el="controls"] {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

@media (max-width: theme('screens.sm')) {
    [data-glide-el="controls"] {
        justify-content: center;
    }
}
</style>
